<template>
  <div>

    <div class="makbuz" id="Yazdir">
      <div class="TermalLogo" v-if="Logo">
        <img :src="'https://cdn.mudu.pro/Drive/upload/' + this.$store.getters.HesapId + '/Genel/'+Logo" width="100%">
      </div>
      <br>
      <div class="Bilgi">
        <svg width="100%" height="15">
          <text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" font-size="16">
            Tahsilat Makbuzu
          </text>
        </svg>
        <table class="table">
          <tbody>
          <tr>
            <td>
              <svg class="pull-left" width="100%" height="10">
                <text x="0" y="8" font-size="8" text-anchor="start">Ad Soyad</text>
              </svg>
            </td>
            <td class="text-right">
              <svg class="pull-right" width="100%" height="10">
                <text x="100%" y="8" font-size="8" font-weight="bold" text-anchor="end">{{ data.Bilgi.AdSoyad }}</text>
              </svg>
            </td>
          </tr>
          <tr>
            <td>
              <svg class="pull-left" width="100%" height="10">
                <text x="0" y="8" font-size="8" text-anchor="start">Bina Adı</text>
              </svg>
            </td>
            <td class="text-right">
              <svg class="pull-right" width="100%" height="10">
                <text x="100%" y="8" font-size="8" font-weight="bold" text-anchor="end">{{ data.Bilgi.BinaAdi }}</text>
              </svg>
            </td>
          </tr>
          <tr>
            <td>
              <svg class="pull-left" width="100%" height="10">
                <text x="0" y="8" font-size="8" text-anchor="start">Mesken Bilgi</text>
              </svg>
            </td>
            <td class="text-right">
              <svg class="pull-right" width="100%" height="10">
                <text x="100%" y="8" font-size="8" font-weight="bold" text-anchor="end">{{ data.Bilgi.Kat }}. Kat
                  {{ data.Bilgi.kNo }} Numara
                </text>
              </svg>
            </td>
          </tr>
          <tr>
            <td>
              <svg class="pull-left" width="100%" height="10">
                <text x="0" y="8" font-size="8" text-anchor="start">Makbuz No</text>
              </svg>
            </td>
            <td class="text-right">
              <svg class="pull-right" width="100%" height="10">
                <text x="100%" y="8" font-size="8" font-weight="bold" text-anchor="end">{{ data.Bilgi.mNo }}</text>
              </svg>
            </td>
          </tr>
          <tr>
            <td>
              <svg class="pull-left" width="100%" height="10">
                <text x="0" y="8" font-size="8" text-anchor="start">Kasa</text>
              </svg>
            </td>
            <td class="text-right">
              <svg class="pull-right" width="100%" height="10">
                <text x="100%" y="8" font-size="8" font-weight="bold" text-anchor="end">{{ data.Bilgi.Kasa }}</text>
              </svg>
            </td>
          </tr>
          <tr>
            <td>
              <svg class="pull-left" width="100%" height="10">
                <text x="0" y="8" font-size="8" text-anchor="start">Ödeme Tarihi</text>
              </svg>
            </td>
            <td class="text-right">
              <svg class="pull-right" width="100%" height="10">
                <text x="100%" y="8" font-size="8" font-weight="bold" text-anchor="end">{{ data.Bilgi.oTarihi }}</text>
              </svg>
            </td>
          </tr>
          <tr>
            <td>
              <svg class="pull-left" width="100%" height="10">
                <text x="0" y="8" font-size="8" text-anchor="start">İşlem Zamanı</text>
              </svg>
            </td>
            <td class="text-right">
              <svg class="pull-right" width="100%" height="10">
                <text x="100%" y="8" font-size="8" font-weight="bold" text-anchor="end">{{ data.Bilgi.iTarihi }}</text>
              </svg>
            </td>
          </tr>
          <tr v-if="data.Bilgi.tZamDurum">
            <td>
              <svg class="pull-left" width="100%" height="10">
                <text x="0" y="8" font-size="8" text-anchor="start">Tahsil Zam</text>
              </svg>
            </td>
            <td class="text-right">
              <svg class="pull-right" width="100%" height="10">
                <text x="100%" y="8" font-size="8" font-weight="bold" text-anchor="end">{{ data.Bilgi.tZam }}</text>
              </svg>
            </td>
          </tr>
          <tr v-if="data.Bilgi.tmKarDurum">
            <td>
              <svg class="pull-left" width="100%" height="10">
                <text x="0" y="8" font-size="8" text-anchor="start">Hizmet Bilgi</text>
              </svg>
            </td>
            <td class="text-right">
              <svg class="pull-right" width="100%" height="10">
                <text x="100%" y="8" font-size="8" font-weight="bold" text-anchor="end">{{ data.Bilgi.tmKar }}TL</text>
              </svg>
            </td>
          </tr>
          <tr v-if="data.Bilgi.KomisyonDurum">
            <td>
              <svg class="pull-left" width="100%" height="10">
                <text x="0" y="8" font-size="8" text-anchor="start">Pos Komisyonu</text>
              </svg>
            </td>
            <td class="text-right">
              <svg class="pull-right" width="100%" height="10">
                <text x="100%" y="8" font-size="8" font-weight="bold" text-anchor="end">{{ data.Bilgi.Komisyon }}TL
                </text>
              </svg>
            </td>
          </tr>
          <tr v-if="data.Bilgi.EmanetDurum">
            <td>
              <svg class="pull-left" width="100%" height="10">
                <text x="0" y="8" font-size="8" text-anchor="start">Emanet</text>
              </svg>
            </td>
            <td class="text-right">
              <svg class="pull-right" width="100%" height="10">
                <text x="100%" y="8" font-size="8" font-weight="bold" text-anchor="end">{{ data.Bilgi.Emanet }}TL</text>
              </svg>
            </td>
          </tr>
          <tr v-if="data.BankaDokum">
            <td>
              <svg class="pull-left" width="100%" height="10">
                <text x="0" y="8" font-size="8" text-anchor="start">Banka Referans No</text>
              </svg>
            </td>
            <td class="text-right">
              <svg class="pull-right" width="100%" height="10">
                <text x="100%" y="8" font-size="8" font-weight="bold" text-anchor="end">{{ data.BankaDokum.Referans }}
                </text>
              </svg>
            </td>
          </tr>
          <tr>
            <td>
              <svg class="pull-left" width="100%" height="10">
                <text x="0" y="8" font-size="8" text-anchor="start">Ödenen</text>
              </svg>
            </td>
            <td class="text-right">
              <svg class="pull-right" width="100%" height="10">
                <text x="100%" y="8" font-size="8" font-weight="bold" text-anchor="end">{{ data.Bilgi.OdemeTutar }}TL
                </text>
              </svg>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div>
        <table class="table">
          <thead>
          <tr>

            <th>
              <svg width="100%" height="10">
                <text x="0" y="8" font-weight="bold" font-size="8" text-anchor="start">
                  Borç Türü
                </text>
              </svg>
            </th>
            <th>
              <svg width="100%" height="10">
                <text x="100%" y="8" font-weight="bold" font-size="8" text-anchor="end">
                  Tutar
                </text>
              </svg>
            </th>
            <th>
              <svg width="100%" height="10">
                <text x="100%" y="8" font-weight="bold" font-size="8" text-anchor="end">
                  Zam
                </text>
              </svg>
            </th>
            <th>
              <svg width="100%" height="10">
                <text x="100%" y="8" font-weight="bold" font-size="8" text-anchor="end">
                  Ödenen
                </text>
              </svg>
            </th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="Tahakkuk in data.Tahakkuk">

            <td>
              <svg width="100%" height="10">
                <text x="0" y="8" font-weight="bold" font-size="8" text-anchor="start">
                  {{ Tahakkuk.Kategori }}
                </text>
              </svg>
            </td>
            <td class="text-right">
              <svg width="100%" height="10">
                <text x="100%" y="8" font-weight="bold" font-size="8" text-anchor="end">
                  {{ Tahakkuk.Tutar }}TL
                </text>
              </svg>
            </td>
            <td class="text-right">
              <svg width="100%" height="10">
                <text x="100%" y="8" font-weight="bold" font-size="8" text-anchor="end">
                  {{ Tahakkuk.ZamTutar }}TL
                </text>
              </svg>
            </td>
            <td class="text-right">
              <svg width="100%" height="10">
                <text x="100%" y="8" font-weight="bold" font-size="8" text-anchor="end">
                  {{ Tahakkuk.Odenecek }}TL
                </text>
              </svg>
            </td>
          </tr>
          </tbody>
          <tfoot>
          <tr>
            <th class="text-right">
              <svg width="100%" height="10">
                <text x="100%" y="8" font-weight="bold" font-size="8" text-anchor="end">
                  MAKBUZ TOPLAMI
                </text>
              </svg>
            </th>
            <th class="text-right">
              <svg width="100%" height="10">
                <text x="100%" y="8" font-weight="bold" font-size="8" text-anchor="end">
                  {{ data.T.T }}TL
                </text>
              </svg>
            </th>
            <th class="text-right">
              <svg width="100%" height="10">
                <text x="100%" y="8" font-weight="bold" font-size="8" text-anchor="end">
                  {{ data.T.Z }}TL
                </text>
              </svg>
            </th>
            <th class="text-right">
              <svg width="100%" height="10">
                <text x="100%" y="8" font-weight="bold" font-size="8" text-anchor="end">
                  {{ data.T.O }}TL
                </text>
              </svg>
            </th>
          </tr>
          </tfoot>
        </table>
        <svg v-if="data.Bilgi.Aciklama" width="100%" height="15">
          <text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" font-size="8">
            Makbuz Açıklama: {{ data.Bilgi.Aciklama }}
          </text>
        </svg>
        <svg v-if="data.Bilgi.BorcDurum" width="100%" height="20">
          <text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" font-size="10">
            Güncel Borcunuz: {{ data.Bilgi.Borc }}TL
          </text>
        </svg>
        <div class="text-center">
          <vrcode
            :value="data.Bilgi.Url"
            helpers="url"
            :options="{size: 100,level: 'L'}"
          ></vrcode>
        </div>
        <div class="text-center">
          <svg data-name="katman 1" xmlns="http://www.w3.org/2000/svg" width="20%"
               height="50px" viewBox="0 0 398.29 76.51">
            <path id="Rounded_Rectangle_2" data-name="Rounded Rectangle 2"
                  d="M122.5,406.3l7,5.9c.8.9,1.3,1.9-1,3.5l-7.1,5.6S141.6,435,141.5,435s3,17.2,2,16.9c-.4-.1-44.9-29.7-44.9-29.7a2.5,2.5,0,0,1,.5-3l19.4-12.9C120.8,404.8,121.1,405.2,122.5,406.3Z"
                  transform="translate(-98.31 -382.5)"/>
            <path id="Rounded_Rectangle_1" data-name="Rounded Rectangle 1"
                  d="M142.4,395.4l10.9,7.4c2.5,1.5,2.5,3.2,2.5,5.9v48.1c0,2.7-1.5,2.3-2.8,2l-11.2-8c-.6-.3-1.1-.4-1.5-2.5V400.4C140.4,397.6,139.6,395.4,142.4,395.4Z"
                  transform="translate(-98.31 -382.5)"/>
            <g class="cls-1">
              <path
                d="M143.7,391.9a1.25,1.25,0,0,1,0-2l12-7.3a.9.9,0,0,1,.5-.1,1.06,1.06,0,0,1,.9.9v15a1.06,1.06,0,0,1-.9.9.9.9,0,0,1-.5-.1Z"
                transform="translate(-98.31 -382.5)"/>
            </g>
            <path
              d="M209.3,455.3v-4.7c-4.8,3.8-10.9,5.7-18.4,5.7-8.6,0-15.3-2.5-20.4-7.6-4.7-4.8-7-10.8-7-18.2,0-7.6,2.4-13.8,7.1-18.5,5.1-5.1,12-7.6,20.7-7.6,7.2,0,13.2,1.8,18,5.5v-5.3h9.8v50.8h-9.8Zm-4.7-37.7c-3.2-3.1-7.8-4.7-13.8-4.7-5.6,0-9.9,1.7-13.1,5.1a17.73,17.73,0,0,0-4.4,12.4c0,5.1,1.5,9.2,4.4,12.2,3.1,3.3,7.5,5,13.1,5s10.1-1.6,13.5-4.9a16.36,16.36,0,0,0,5-12.3C209.3,425.1,207.7,420.8,204.6,417.6Z"
              transform="translate(-98.31 -382.5)"/>
            <path
              d="M232.7,400.1c-2.2,0-3.7-1.2-4.7-3.7v-7.5c1.2-2.4,2.7-3.7,4.7-3.7,1.6,0,3.3,1.1,5.1,3.2v8.7Q235.1,400.1,232.7,400.1ZM228,455.2V403.5h9.8v51.7Z"
              transform="translate(-98.31 -382.5)"/>
            <path
              d="M288.7,455.3v-4.9c-4.8,3.9-10.9,5.9-18.4,5.9-8.6,0-15.3-2.6-20.4-7.9-4.7-4.9-7-11.2-7-18.8,0-7.9,2.4-14.3,7.1-19.1,5-5.3,11.9-7.9,20.7-7.9q10.8,0,18,5.7v-22h9.8v69.1l-9.8-.1ZM284,416.2c-3.2-3.3-7.8-4.9-13.8-4.9q-8.25,0-12.9,5.1c-3.1,3.4-4.6,7.8-4.6,13.1s1.5,9.5,4.4,12.7c3.1,3.5,7.5,5.2,13.1,5.2s10.1-1.7,13.5-5.1a17.33,17.33,0,0,0,5-12.8C288.7,423.9,287.1,419.5,284,416.2Z"
              transform="translate(-98.31 -382.5)"/>
            <path
              d="M350.2,455.3v-4.7c-4.8,3.8-10.9,5.7-18.4,5.7-8.6,0-15.3-2.5-20.4-7.6-4.7-4.8-7-10.8-7-18.2,0-7.6,2.4-13.8,7.1-18.5,5.1-5.1,12-7.6,20.7-7.6,7.2,0,13.2,1.8,18,5.5v-5.3H360v50.8h-9.8Zm-4.7-37.7c-3.2-3.1-7.8-4.7-13.8-4.7-5.6,0-9.9,1.7-13.1,5.1a17.73,17.73,0,0,0-4.4,12.4c0,5.1,1.5,9.2,4.4,12.2,3.1,3.3,7.5,5,13.1,5s10.1-1.6,13.5-4.9a16.36,16.36,0,0,0,5-12.3C350.2,425.1,348.6,420.8,345.5,417.6Z"
              transform="translate(-98.31 -382.5)"/>
            <path d="M385,415.4v39.8h-9.6l-.2-39.8H365v-8.9h10.2V392.7H385v13.8h10.3v8.9Z"
                  transform="translate(-98.31 -382.5)"/>
            <path d="M399.8,455.2V405.5h9.8v49.7Z" transform="translate(-98.31 -382.5)"/>
            <path
              d="M486.9,455.2V423.4c0-3.7-.9-6.3-2.6-7.9s-4.5-2.4-8.4-2.4c-4.3,0-7.7,1.1-10.1,3.2a10.67,10.67,0,0,0-3.6,8.5v30.6h-9.8v-32c0-3.7-.9-6.3-2.7-7.9s-4.7-2.4-8.6-2.4a12.81,12.81,0,0,0-10.2,4.4,15.3,15.3,0,0,0-3.4,10.2v27.7h-9.8V405.3h9.8v3.1a25.58,25.58,0,0,1,14.6-4.1c6.9,0,12.3,2.1,16.1,6.4,3.9-4.3,9.8-6.4,17.5-6.4,6.7,0,11.9,1.5,15.5,4.6s5.4,7.6,5.4,13.5v32.8Z"
              transform="translate(-98.31 -382.5)"/>
          </svg>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: ['data', 'Logo'],
  data() {
    return {
      windowRef: null,
    };
  },
  watch: {
    open(newOpen) {
      if (newOpen) {
        this.openPortal();
      } else {
        this.closePortal();
      }
    }
  },
  methods: {

    openPortal() {

      this.windowRef = window.open(
        "",
        "",
        "width=400,height=800,left=100,top=100"
      );
      this.windowRef.document.write('<html><head><title>Aidatım Yazıcı</title>' +
        '<link href="https://fonts.googleapis.com/css?family=Google+Sans:700,700i&amp;subset=latin-ext" rel="stylesheet">' +
        '<link rel="stylesheet" type="text/css" href="https://cdn.mudu.pro/Style/Print/Genel.css">' +
        '<link rel="stylesheet" type="text/css" href="https://cdn.mudu.pro/Style/Print/Termal.css?v1">' +
        '</head><body>');
      this.windowRef.document.body.appendChild(this.$el);
      this.windowRef.document.write('</body></html>');

      var is_chrome = function () {
        return Boolean(this.windowRef.chrome);
      }
      if (is_chrome) {
        setTimeout(() => {
          this.windowRef.print();
        }, 1000);
        setTimeout(() => {
          this.windowRef.close();
        }, 5000);
      } else {
        setTimeout(() => {
          this.windowRef.print();
        }, 1000);
        this.windowRef.close();
      }
      this.windowRef.addEventListener("beforeunload", this.closePortal);

    },
    closePortal() {

      if (this.windowRef) {
        this.windowRef.close();
        this.windowRef = null;
        this.$emit("close");
      }

    }
  },
  mounted() {
    if (this.data) {
      this.openPortal();
    }
  },
  beforeDestroy() {
    if (this.windowRef) {
      this.closePortal();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Yazdir/TermalMakbuz.vue